var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-card',[_c('DataListMensageria',{attrs:{"subjectPermission":_vm.subjectPermission},on:{"newEvent":function($event){return _vm.novoAssunto()}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }